export default __webpack_public_path__ + "images/3d0e244178ec8a4590386d9847d7b37c-1_web_1919x543.jpg";